module.exports = __webpack_public_path__ + "img/SelectedFeedbackGood.1fba5625.png";